import Contacts from '../Contacts'
import './Footer.module.scss'
export default function Footer() {
    return (
        <footer>
            <Contacts/>
        </footer>
    )
}